import { Checkbox, Tooltip } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { CTEItemDialog } from "./item-detail/ItemDialogCTE";

const numeral = require("numeral");

interface Props {
  items: any[];
  entrada_saida: string;
  modelo: string;
}

@observer
export class DetalhamentoCteTable extends React.Component<Props, {}> {

  obs = observable({
    viewing: null as any,
  });

  handleContest(item: any) {
    ResultadoStore.obs.contestarItems = [];
    this.onSelect(item, true);
    ResultadoStore.obs.openContestacaoLote = true;
  }

  handleView(item: any) {
    this.obs.viewing = item;
  }

  handleViewClose = () => {
    this.obs.viewing = null;
  };

  onSelectAll = async (isSelect: boolean) => {
    if (isSelect) {
      let data = this.props.items
        ?.filter(item => !this.isProcessing(item._id))
        .map(item => ({
          id: item._id,
          data: item.data,
        }));
      ResultadoStore.setContestarItemsList(data);
    } else {
      ResultadoStore.resetContestarItems();
    }
  };

  onSelect = async (item: any, checked: boolean) => {
    let data = {
      id: item._id || item.id,
      data: item.data,
    };
    if (checked) {
      ResultadoStore.setContestarItems(data);
    } else {
      ResultadoStore.deleteByIdContestarItems(item._id || item.id);
    }
  };

  isSelected(id: string) {
    return ResultadoStore.obs.contestarItems?.some(v => v.id === id) || false;
  }

  isProcessing(id: string) {
    return ResultadoStore.obs.itens_processando.indexOf(id) !== -1;
  }

  isAllSelected() {
    const selectable = this.props.items?.filter(item => !this.isProcessing(item._id)) || [];
    if (!selectable.length) return false;
    return selectable.every(item => this.isSelected(item._id));
  }

  renderActions(item: any) {
    const niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    const isDisabled = niveis_acesso.indexOf("c2") === -1;

    if (!AppStore.obs1.usuario) return null;

    if (this.isProcessing(item._id)) {
      return (
        <div className="detalhamento-card-actions">
          <button className="detalhamento-action-btn" onClick={() => this.handleView(item)}>
            <img src="/images/contestar.svg" width={20} />
          </button>
          <Tooltip content="Processando...">
            <img src="/images/icone-relogio.png" width={24} />
          </Tooltip>
        </div>
      );
    }

    return (
      <div className="detalhamento-card-actions">
        <Tooltip content="Detalhes">
          <button className="detalhamento-action-btn" onClick={() => this.handleView(item)}>
            <img src="/images/contestar.svg" width={20} />
          </button>
        </Tooltip>
        {!isDisabled && (
          item.contestacao_calc_id
            ? <Tooltip content="Contestado">
              <button className="detalhamento-action-btn" onClick={() => this.handleContest(item)}>
                <img src="/images/contestado.png" width={20} />
              </button>
            </Tooltip>
            : <Tooltip content="Contestar">
              <button className="detalhamento-action-btn" onClick={() => this.handleContest(item)}>
                <img src="/images/contestar.png" width={20} />
              </button>
            </Tooltip>
        )}
      </div>
    );
  }

  renderViewDialog() {
    return (
      <CTEItemDialog
        modelo={this.props.modelo}
        item={this.obs.viewing}
        entrada_saida={this.props.entrada_saida}
        onClose={this.handleViewClose}
      />
    );
  }

  renderCard(item: any) {
    const id = item._id;
    const selected = this.isSelected(id);
    const isProcessing = this.isProcessing(id);

    const cardClasses = [
      "detalhamento-card",
      selected ? "card-selected" : "",
    ].filter(Boolean).join(" ");

    const cnpj = this.props.entrada_saida === "Saída" ? item.cnpj_destino : item.cnpj_origem;

    return (
      <div key={id} className={cardClasses}>
        {/* Header */}
        <div className="detalhamento-card-header">
          <div className="detalhamento-card-header-left">
            {!isProcessing && (
              <Checkbox
                checked={selected}
                onChange={(e) => this.onSelect(item, (e.target as HTMLInputElement).checked)}
                style={{ marginBottom: 0 }}
              />
            )}
            <span className="detalhamento-card-descricao">
              {item.serie}/{item.numero} - {item.calc || ""}
            </span>
          </div>
          {this.renderActions(item)}
        </div>

        {/* Body */}
        <div className="detalhamento-card-body">
          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Série / Nota</span>
            <span className="detalhamento-field-value">{item.serie} / {item.numero}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Emissão</span>
            <span className="detalhamento-field-value">{moment(item.data).format("DD/MM/YYYY")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CNPJ Emitente</span>
            <span className="detalhamento-field-value">{cnpj || "-"}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CFOP</span>
            <span className="detalhamento-field-value">{item.cfop || "-"}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">CST</span>
            <span className="detalhamento-field-value">{item.cst || "-"}</span>
          </div>

          <div className="detalhamento-field detalhamento-field-lg">
            <span className="detalhamento-field-label">Chave</span>
            <span className="detalhamento-field-value" style={{ wordBreak: "break-all", fontSize: 11 }}>{item.chave || "-"}</span>
          </div>

          <div className="detalhamento-field detalhamento-field-xl">
            <span className="detalhamento-field-label">Cálculo</span>
            <span className="detalhamento-field-value">{item.calc || "-"}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Valor</span>
            <span className="detalhamento-field-value">R$ {numeral(item.valor).format("0,0.00")}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">A Pagar</span>
            <span className="detalhamento-field-value valor-pagar">R$ {numeral(item.valor_icms_ant).format("0,0.00")}</span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const allSelected = this.isAllSelected();
    const totalItems = this.props.items?.length || 0;
    const selectedCount = ResultadoStore.obs.contestarItems?.length || 0;

    return (
      <>
        <div className="detalhamento-container">
          <div className="detalhamento-select-all">
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Checkbox
                checked={allSelected}
                indeterminate={selectedCount > 0 && !allSelected}
                onChange={() => this.onSelectAll(!allSelected)}
                style={{ marginBottom: 0 }}
              />
              <span>
                {selectedCount > 0
                  ? `${selectedCount} de ${totalItems} selecionado(s)`
                  : `${totalItems} resultado(s)`
                }
              </span>
            </div>
          </div>

          {this.props.items?.map(item => this.renderCard(item))}
        </div>

        {this.obs.viewing && this.renderViewDialog()}
      </>
    );
  }
}

export default DetalhamentoCteTable;
